import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ContentService } from '@content/content.service';
import { ContentItem } from '@model/content-item';

export const contentNewsItemsResolver: ResolveFn<ContentItem[]> = () =>
  inject(ContentService).contentNewsItems();
